export default __webpack_public_path__ + "static/media/about-ima.30007123.png";